import React, {useRef, useState} from 'react';
import {CardElement, Elements, injectStripe, StripeProvider} from 'react-stripe-elements';
import {FormGroup, Label, Row} from 'reactstrap';
import './StripeElements.scss';
import StripePowered from '../../images/powered.svg';

const createOptions = () => {
    return {
        style: {
            base: {
                width: '100%',
                fontSize: '16px',
                color: '#424770',
                fontFamily: 'Open Sans, sans-serif',
                letterSpacing: '0.025em',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#c23d4b',
            },
        },
    };
};

const _CardForm = ({stripe, setIsValidCard, setStripePaymentMethod}) => {
    const [errorMessage, setErrorMessage] = useState('');
    const cardElement = useRef();

    const handleCardChange = async (e) => {
        if (e.complete) {
            const {error, token} = await stripe.createToken();
            if (token) {
                setStripePaymentMethod(token.id);
                setIsValidCard(true);
            }
            if (error) {
                setErrorMessage(error.message);
            }
        } else {
            setIsValidCard(false);
        }
        e.error ? setErrorMessage(e.error.message) : setErrorMessage('');
    };
    const generateCardNumberField = () =>
        <FormGroup bsSize='small' className='credential_input'>
            <Label className='d-flex'>
                <p className='bold bottom0'>CARD</p>
            </Label>
            <CardElement
                ref={cardElement}
                onChange={(e) => handleCardChange(e)}
                {...createOptions()}
            />
        </FormGroup>;

    return (
        <div className='CardSubscritionDemo'>
            <form>

                <Row className='justify-content-center mt-40'>
                    {generateCardNumberField()}
                </Row>
                <Row className='justify-content-center'>
                    <FormGroup bsSize='small' className='credential_input stripe-powered'>
                        <img src={StripePowered} alt='Stripe' style={{width: 150}} />
                    </FormGroup>
                </Row>
                <Row className='justify-content-center'>
                    <div className='text-danger'>
                        <strong>{errorMessage}</strong>
                    </div>
                </Row>
            </form>
        </div>
    );
};

const CardForm = injectStripe(_CardForm);

export const PaymentElement = ({apiKey, setIsValidCard, setStripePaymentMethod}) => (
    <StripeProvider apiKey={apiKey}>
        <Elements>
            <CardForm
                setIsValidCard={setIsValidCard}
                setStripePaymentMethod={setStripePaymentMethod}
            />
        </Elements>
    </StripeProvider>
);



// WEBPACK FOOTER //
// ./src/containers/stripe/StripeElements.js